import React from 'react';
import moment from 'moment';
import { NumberInput, DatePicker, Modal} from 'hyperdb-utils';

const SeasonalConditionsForm = (props) => {
  // const minYear = moment().subtract(1, 'year').format('YYYY');
  // const maxYear = moment().add(1, 'year').format('YYYY');
  const handleChangeDate = (attributeName, field) => {
    const { value } = field;
    const date = value ? moment(value).format('YYYY-MM-DD') : null;
    props.onChange(attributeName, { value: date });
  };
  const {date_start, date_end} = props.seasonalCondition;
  const openFrom = date_start && date_end ? (date_start < date_end ? date_start : date_end) : date_end || date_start;
  const openTo = date_end && date_start ? (date_end > date_start ? date_end : date_start) : date_start || date_end;
  return (
    <div>
      <fieldset>
        <DatePicker
          label="From"
          name="from"
          value={ props.seasonalCondition.date_start }
          maxValue={ props.seasonalCondition.date_end }
          openToDate={ openFrom }
          onChange={ handleChangeDate.bind(null, 'date_start') }
        />
      <DatePicker
          label="To"
          name="to"
          value={ props.seasonalCondition.date_end }
          minValue={ props.seasonalCondition.date_start }
          openToDate={ openTo }
          onChange={ handleChangeDate.bind(null, 'date_end') }
          error={ props.errorDates ? 'End date should be >= begin date' : null }
        />
      </fieldset>
      <fieldset>
        <NumberInput
          label="Minimum Stay"
          name="min_stay"
          value={ props.seasonalCondition.min_stay }
          onChange={ props.onChange.bind(null, 'min_stay') }
        />
      </fieldset>
    </div>
  );
};

SeasonalConditionsForm.propTypes = {
  seasonalCondition: React.PropTypes.object,
  onChange: React.PropTypes.func,
  errorDates: React.PropTypes.bool,
};

export default SeasonalConditionsForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/SeasonalConditionsForm.jsx